__turbopack_context__.v({
  "Content": "OlEvEa_Content",
  "Description": "OlEvEa_Description",
  "Header": "OlEvEa_Header",
  "Icon": "OlEvEa_Icon",
  "Root": "OlEvEa_Root",
  "Root--BorderBottom": "OlEvEa_Root--BorderBottom",
  "Root--Disabled": "OlEvEa_Root--Disabled",
  "Root--Grey": "OlEvEa_Root--Grey",
  "Root--Open": "OlEvEa_Root--Open",
  "Root--RoundedBorders": "OlEvEa_Root--RoundedBorders",
  "Root--Shadow": "OlEvEa_Root--Shadow",
  "Root--Toolbox": "OlEvEa_Root--Toolbox",
  "Root--WithGrayBg": "OlEvEa_Root--WithGrayBg",
  "Title": "OlEvEa_Title",
  "TitleWrapper": "OlEvEa_TitleWrapper",
  "skeleton-loading": "OlEvEa_skeleton-loading",
});
